import { Pipe, PipeTransform } from '@angular/core';
import { SiteSetupService } from 'app/client-core/services/site-setup';

@Pipe({
  name: 'siteMenuTranslation'
})
export class SiteMenuTranslationPipe implements PipeTransform {
  constructor(
    private siteSetupService: SiteSetupService
  ) {
  }

  transform(value: any): any {
    const menus = this.siteSetupService._getCachedSiteMenu();
    if (menus) {
      return menus.find(m => m.name == value).displayName;
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/site-menu-translation.pipe.ts